<template>
  <div class="mb">
    <van-cell-group v-if="schoolBuildingTeam" class="kuang">
      <van-cell v-if="school" title="学校名称" :value="school" />
      <van-cell
        v-if="schoolBuildingTeam == 1"
        title="学校是否建队"
        :value="format(schoolBuildingTeam, 1)"
      />
      <van-cell v-if="schoolBuildingTeam == 2" title="未建队" />

      <van-cell v-if="schoolBuildingTeam == 3" title="不符合建队条件" />

      <van-cell
        v-if="isBrigadeCounselor == 1"
        title="是否为大队辅导员"
        :value="format(isBrigadeCounselor, 1)"
      />
      <van-cell v-if="isBrigadeCounselor == 2" title="未设置大队辅导员" />
      <div v-if="isBrigadeCounselor == 1">
        <van-cell v-if="name" title="姓名" :value="name" />
        <van-cell v-if="zzmm" title="政治面貌" :value="format(zzmm, 2)" />
        <van-cell v-if="tel" title="手机号" :value="tel" />
        <van-cell v-if="job" title="校内职务" :value="format(job, 3)" />
        <van-cell v-if="title" title="职称" :value="format(title, 4)" />
      </div>

      <div v-if="schoolBuildingTeam == 1">
        <van-cell v-if="squadronNum" title="中队数量" :value="squadronNum" />
        <van-cell
          v-if="squadronCounselorsNum"
          title="中队辅导员人数"
          :value="squadronCounselorsNum"
        />
        <van-cell
          v-if="viceCounselor"
          title="副大队辅导员人数"
          :value="format(viceCounselor, 19)"
        />

        <van-cell v-if="youngNum" title="少先队员人数" :value="youngNum" />
        <van-cell
          title="今年推荐作为团的发展对象的少先队员人数"
          :value="recommender || 0 + '人'"
        />
        <van-cell
          title="大队聘请的校外辅导员总人数"
          :value="brigadeOutsideCounselorsNum"
        />
        <van-cell
          title="中队聘请的校外辅导员总人数"
          :value="squadronOutsideCounselorsNum"
        />

        <van-cell
          v-if="schoolsgw == 1"
          title="学校是否成立学校少工委"
          :value="format(schoolsgw, 1)"
        />
        <van-cell v-if="schoolsgw == 2" title="未成立学校少工委" />
        <div v-if="schoolsgw == 1">
          <van-cell v-if="sgwName" title="学校少工委主任姓名" :value="sgwName" />
          <van-cell v-if="sgwJob" title="学校少工委主任职务" :value="format(sgwJob, 5)" />
          <van-cell v-if="sdhsj" title="本届少代会召开时间" :value="format(sdhsj, 6)" />
        </div>
      </div>
    </van-cell-group>
    <van-empty v-else description="暂无填写" />
    <nav-bar />
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { getCounselorData } from "@/service/form";
import { format } from "@/common/js/utils";
import navBar from "@/components/NavBar";
import { getLocal } from "@/common/js";
export default {
  name: "counselor",
  components: {
    navBar,
  },
  setup() {
    const state = reactive({
      isBrigadeCounselor: null,
      job: null,
      jobStr: null,
      name: null,
      schoolBuildingTeam: null,
      schoolsgw: null,
      sdhsj: null,
      sgwJob: null,
      sgwJobStr: null,
      sgwName: null,
      squadronCounselorsNum: 0,
      squadronNum: 0,
      brigadeOutsideCounselorsNum: 0,
      squadronOutsideCounselorsNum: 0,
      tel: null,
      title: null,
      titleStr: null,
      youngNum: 0,
      zzmm: null,
      zzmmStr: null,
      school: null,
      viceCounselor: null,
      recommender: 0,
    });

    onMounted(async () => {
      const res = await getCounselorData();
      const { code = 0, data } = res;
      if (code == 10000 && data) {
        //   赋值
        Object.assign(state, data);
      }
      const school = await getLocal("dsj_school");
      // console.log("school", school);
      if (school) {
        state.school = school;
      }
    });

    return {
      ...toRefs(state),
      format,
    };
  },
};
</script>
<style lang="less" scoped>
.mb {
  margin-bottom: 1.8rem;
}
</style>
